import axios from "axios";

const api = axios.create({
  // baseURL: window._env_?.REkcACT_APP_API_URL || "http://localhost/backend_inv",
  baseURL: window._env_?.REACT_APP_API_URL || "https://patlasp.id/backend_inv",
});

const getToken = () =>
  localStorage.getItem("token") || sessionStorage.getItem("token");

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Cek jika respons error ada dan statusnya 401 (Unauthorized)
    if (error.response?.status === 401) {
      // Daftar kunci untuk dibersihkan saat sesi berakhir
      [
        "token",
        "NIP",
        "username",
        "namaLengkap", // ✅ Tambahan untuk konsistensi
        "idUser", // ✅ Perbaikan Casing: Ganti dari 'IdUser'
        "idRole", // ✅ Perbaikan Casing: Ganti dari 'IdRole'
        "idDepartemen",
        "isActive",
      ].forEach((k) => {
        localStorage.removeItem(k);
        sessionStorage.removeItem(k);
      });

      // Set flag 'expired' agar AuthContext dapat menampilkan toast saat mounting
      localStorage.setItem("expired", "1");

      // 🛑 Redirect ke halaman login yang benar
      // window.location.href = "/PersediaanRsud/login";
      window.location.href = "/backend_inv/login";
    }
    return Promise.reject(error);
  }
);

export default api;
